/* ======= Common CSS ======= */

// Basic css
import "../assets/style.css"

// Basic scss
import "../assets/scss/_style.scss"
